// fw Button — the mock's .btn.
//
// Named `Button` in here and exported as `FwButton` from the barrel so it
// cannot be confused with the old ui Button while both are in the bundle.
//
// The defaults that matter, same reasoning as ui/components/Button.js:
//   - type="button": a <button> inside a <form> defaults to submit.
//   - disabled while loading: the second tap on bad signal hits a dead button.

import React from 'react';
import { Icon } from '../../components/Icon.js';
import './Button.css';

export const BUTTON_VARIANTS = ['primary', 'ghost', 'go', 'stop', 'quiet'];
export const BUTTON_SIZES = ['md', 'lg'];

export const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    full = false,
    // Let the label WRAP instead of being cut off with an ellipsis. Off by
    // default: a button that grows taller changes a row's height, and most
    // labels here are one or two words. Reach for it when the label is a
    // sentence a person has to read to choose — StopSheet's stop reasons are
    // the case it was added for. `full` already implies it.
    wrap = false,
    icon,
    loading = false,
    disabled = false,
    type = 'button',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const v = BUTTON_VARIANTS.includes(variant) ? variant : 'primary';
  const s = BUTTON_SIZES.includes(size) ? size : 'md';
  const cls = [
    'fw-btn',
    `fw-btn--${v}`,
    `fw-btn--${s}`,
    full ? 'fw-btn--full' : '',
    wrap ? 'fw-btn--wrap' : '',
    loading ? 'fw-btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading ? 'true' : undefined}
      {...rest}
    >
      {icon ? <Icon name={icon} className="fw-btn__icon" /> : null}
      {children !== undefined && children !== null ? <span className="fw-btn__label">{children}</span> : null}
    </button>
  );
});

export default Button;
